export default __webpack_public_path__ + "static/media/ClockTickingShort.95105849.mp3";